import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask";
import TextInput from "../TextInput";
import WagerTypes from "./WagerTypes";
import { successMsg } from "../SuccessHandler";
import ErrorCodes from "../../constants/ErrorCodes";
import { useUpdateFunctions } from "../../functions";
import ConfirmDialog from "../utilities/ConfirmDialog";

const RaceInfo = ({
  raceInfo,
  setRaceInfo,
  lengthRaces,
  RaceID,
  stateTracks,
  setStateTracks,
  userInfo,
  racesTracks,
  setSessionNoLongerExists,
  selectOption,
  isDisabled,
}) => {
  const [errors, setErrors] = useState({});
  const datePickerRef = useRef(null);
  const { updateRaceInfo } = useUpdateFunctions();

  useEffect(() => {
    setErrors({});
  }, [raceInfo.RaceID, raceInfo.RaceStatus]);

  // Validate if there are errors in the information provided for the race.
  let classMTP = "",
    classOffDate = "",
    classOffDateT = "",
    classPostDateT = "",
    invalidMTP = "",
    invalidDistance = "",
    invalidPurse = "",
    invalidClass = "",
    invalidSurface = "",
    invalidPostTime = "",
    invalidOffTime = "";

  if (errors) {
    if (errors.offTimeT || errors.offDate) {
      invalidOffTime = (
        <>
          <div
            style={{
              width: "100%",
              fontSize: "80%",
              color: "#dc3545",
            }}
          >
            {errors.offTimeT
              ? errors.offTimeT
              : errors.offDate
                ? errors.offDate
                : ""}
          </div>
        </>
      );

      errors.offTimeT && (classOffDateT = " is-invalid");
      errors.offTimeT && errors.offDate && (classOffDate = " is-invalid");
      !errors.offTimeT && errors.offDate && (classOffDate = " is-invalid");
      errors.offDate &&
        raceInfo.OffTimeT === "aN:aN:aN" &&
        (classOffDateT = " is-invalid");
    }

    if (errors.postTimeT) {
      invalidPostTime = (
        <>
          <div
            style={{
              width: "100%",
              fontSize: "80%",
              color: "#dc3545",
            }}
          >
            {errors.postTimeT ? errors.postTimeT : ""}
          </div>
        </>
      );

      errors.postTimeT && (classPostDateT = " is-invalid");
    }

    if (errors.mtp) {
      invalidMTP = (
        <>
          <div
            style={{
              width: "100%",
              fontSize: "80%",
              color: "#dc3545",
            }}
          >
            {errors.mtp}
          </div>
        </>
      );
      classMTP = " is-invalid";
    }

    if (errors.distance) {
      invalidDistance = errors.distance;
    }

    if (errors.surface) {
      invalidSurface = errors.surface;
    }

    if (errors.class) {
      invalidClass = errors.class;
    }

    if (errors.purse) {
      invalidPurse = errors.purse;
    }

    if (errors.purseInv) {
      invalidPurse = errors.purseInv;
    }
  }

  // This function executes the onChange for changes made to the Race Info fields.
  const onChange = (e) => {
    const { name, value } = e.target;

    if (name === "MTP") {
      if (!/^\d*$/.test(value)) return;
      if (value !== "" && Number(value) > 255) return;
      setRaceInfo({
        ...raceInfo,
        MTP: value,
        LastModUsername: localStorage.getItem("userName"),
      });
      return;
    }

    let newValue = value;

    if (name === "CloseMethod") {
      newValue = parseInt(value, 10);
    }

    if (name === "Purse") {
      newValue = value.replace(/\D/g, "");
      newValue = newValue ? parseInt(newValue, 10) : 0;
    }

    if (name === "RaceStatus") {
      setErrors({});
    }

    setRaceInfo({
      ...raceInfo,
      [name]: newValue,
      LastModUsername: localStorage.getItem("userName"),
    });
  };

  // The StakeGrade number is formatted as a Roman numeral.
  let divSteak, steakGrade;
  if (raceInfo.StakeGrade === 1) {
    steakGrade = " - I";
  } else if (raceInfo.StakeGrade === 2) {
    steakGrade = " - II";
  } else if (raceInfo.StakeGrade === 3) {
    steakGrade = " - III";
  } else {
    steakGrade = " ";
  }

  // If the StakeGrade is different from zero, a golden color is given to the Race Details header.
  if (raceInfo.StakeName !== "" || raceInfo.StakeGrade !== 0) {
    divSteak = (
      <>
        <div className="card">
          <div
            className="card-header"
            id="headingDetails"
            style={{ backgroundColor: "rgb(182, 158, 0)" }}
            data-toggle="collapse"
            data-target="#collapseDetails"
            aria-expanded="true"
          >
            <h5 className="mb-0">
              <a
                className="lead m-t-10"
                style={{
                  textDecoration: "none",
                  color: "#000000",
                }}
                href="#!"
                data-toggle="collapse"
                data-target="#collapseDetails"
                aria-expanded="false"
              >
                {raceInfo.StakeName} {steakGrade}
              </a>
            </h5>
          </div>
          <div
            id="collapseDetails"
            className="collapse card-body"
            aria-labelledby="headingDetails"
          >
            <div className="row">
              <div className="col-sm-6 col-lg-3" key="class">
                <TextInput
                  id="Class"
                  label="Class"
                  name="Class"
                  type="text"
                  value={raceInfo.Class}
                  onChange={onChange}
                  error={invalidClass}
                  changeColor={true}
                  maxLength={100}
                />
              </div>
              <div className="col-sm-6 col-lg-3">
                <TextInput
                  id="Purse"
                  label="Purse"
                  name="Purse"
                  type="number"
                  value={parseFloat(raceInfo.Purse || 0).toFixed(0)}
                  onChange={onChange}
                  error={invalidPurse}
                  changeColor={true}
                />
              </div>
              <div className="col-sm-6 col-lg-3">
                <TextInput
                  id="Surface"
                  label="Surface"
                  name="Surface"
                  type="text"
                  value={raceInfo.Surface}
                  onChange={onChange}
                  error={invalidSurface}
                  changeColor={true}
                  maxLength={10}
                />
              </div>
              <div className="col-sm-6 col-lg-3">
                <TextInput
                  id="Distance"
                  label="Distance"
                  name="Distance"
                  type="text"
                  value={raceInfo.Distance}
                  onChange={onChange}
                  error={invalidDistance}
                  changeColor={true}
                  maxLength={15}
                />
              </div>
            </div>
            <div className="row m-t-20 col-sm-12">
              <label htmlFor="RaceDesc" className="lead">
                Race Description
              </label>
            </div>
            <textarea
              className="form-control"
              onChange={onChange}
              name="RaceDesc"
              value={raceInfo.RaceDesc}
              maxLength={60}
            >
              {raceInfo.RaceDesc}
            </textarea>
          </div>
        </div>
      </>
    );
  } else {
    divSteak = (
      <div className="card">
        <div
          className="card-header"
          id="headingDetails"
          style={{ backgroundColor: "#e1e1e1" }}
          data-toggle="collapse"
          data-target="#collapseDetails"
          aria-expanded="false"
        >
          <h5 className="mb-0">
            <a
              className="lead m-t-10"
              style={{
                textDecoration: "none",
                color: "#000000",
              }}
              href="#!"
              data-toggle="collapse"
              data-target="#collapseDetails"
              aria-expanded="false"
            >
              Race Details
            </a>
          </h5>
        </div>
        <div
          id="collapseDetails"
          className="collapse card-body"
          aria-labelledby="headingDetails"
        >
          <div className="row">
            <div className="col-sm-6 col-lg-3" key="class">
              <TextInput
                id="Class"
                label="Class"
                name="Class"
                type="text"
                value={raceInfo.Class}
                onChange={onChange}
                error={invalidClass}
                changeColor={true}
                maxLength={100}
              />
            </div>
            <div className="col-sm-6 col-lg-3" key="purse">
              <TextInput
                id="Purse"
                label="Purse"
                name="Purse"
                type="number"
                value={parseFloat(raceInfo.Purse || 0).toFixed(0)}
                onChange={onChange}
                error={invalidPurse}
                changeColor={true}
              />
            </div>
            <div className="col-sm-6 col-lg-3">
              <TextInput
                id="Surface"
                label="Surface"
                name="Surface"
                type="text"
                value={raceInfo.Surface}
                onChange={onChange}
                error={invalidSurface}
                changeColor={true}
                maxLength={10}
              />
            </div>
            <div className="col-sm-6 col-lg-3">
              <TextInput
                id="Distance"
                label="Distance"
                name="Distance"
                type="text"
                value={raceInfo.Distance}
                onChange={onChange}
                error={invalidDistance}
                changeColor={true}
                maxLength={15}
              />
            </div>
          </div>
          <div className="row m-t-20 col-sm-12">
            <label htmlFor="RaceDesc" className="lead">
              Race Description
            </label>
          </div>
          <textarea
            className="form-control"
            onChange={onChange}
            name="RaceDesc"
            value={raceInfo.RaceDesc}
            maxLength={60}
          >
            {raceInfo.RaceDesc}
          </textarea>
        </div>
      </div>
    );
  }

  // OffTime handler
  const offDateChange = (dateO) => {
    const updatedErrors = { ...errors };
    if (dateO !== null) {
      delete updatedErrors.offDate;
      delete updatedErrors.offTimeT;
    } else {
      if (raceInfo.RaceStatus === "C") {
        updatedErrors.offDate = "Date is required";
      } else {
        delete updatedErrors.offDate;
        delete updatedErrors.offTimeT;
      }
    }
    setErrors(updatedErrors);

    if (dateO === null) {
      setRaceInfo({
        ...raceInfo,
        OffDate: "",
        OffTime: "",
        OffTimeT: raceInfo.OffTimeT || " : : ",
      });
    } else {
      const date = new Date(dateO);
      const dateString =
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + date.getDate()).slice(-2) +
        "/" +
        date.getFullYear();

      const isValidTime =
        raceInfo.OffTimeT &&
        /^\d{2}:\d{2}:\d{2}$/.test(raceInfo.OffTimeT.trim());
      const offTimeT = isValidTime ? raceInfo.OffTimeT : "00:00:00";

      setRaceInfo({
        ...raceInfo,
        OffDate: dateString,
        OffTimeT: offTimeT,
        OffTime: `${dateString} ${offTimeT}`,
      });
    }
  };

  const offTimeChange = (event) => {
    const value = event.target.value;
    const cleaned = value.replace(/[^0-9]/g, "");

    const updatedErrors = { ...errors };
    delete updatedErrors.offTimeT;
    delete updatedErrors.offDate;
    setErrors(updatedErrors);

    let dateToUse = raceInfo.OffDate;

    if (!dateToUse || isNaN(Date.parse(dateToUse))) {
      const today = new Date();
      const month = ("0" + (today.getMonth() + 1)).slice(-2);
      const day = ("0" + today.getDate()).slice(-2);
      const year = today.getFullYear();
      dateToUse = `${month}/${day}/${year}`;
    }

    const newRaceInfo = {
      ...raceInfo,
    };

    // Si está vacío
    if (cleaned.trim() === "") {
      newRaceInfo.OffTimeT = " : : ";
      newRaceInfo.OffTime = `${dateToUse} 00:00:00`;
    } else {
      newRaceInfo.OffTimeT = value;
      newRaceInfo.OffTime = `${dateToUse} ${value}`;
    }

    // Solo agregar OffDate si OffTimeT es válido
    const isValidTime =
      newRaceInfo.OffTimeT !== "aN:aN:aN" &&
      newRaceInfo.OffTimeT !== " : : " &&
      newRaceInfo.OffTimeT.trim() !== "";

    if (isValidTime) {
      newRaceInfo.OffDate = dateToUse;
    }

    setRaceInfo(newRaceInfo);
  };

  const handleCalendarClose = () => {
    const inputValue = datePickerRef.current?.input?.value;

    if (!inputValue || inputValue.trim() === "") {
      const now = new Date();
      postDateChange(now);
    }
  };

  // PostTime handler
  const postTimeChange = (event) => {
    const value = event.target.value;
    const cleaned = value.replace(/[^0-9]/g, "");

    const updatedErrors = { ...errors };
    delete updatedErrors.postTimeT;

    if (cleaned.trim() === "") {
      setRaceInfo({
        ...raceInfo,
        PostTimeT: "00:00:00",
        PostTime: raceInfo.PostDate + " 00:00:00",
      });
    } else {
      setRaceInfo({
        ...raceInfo,
        PostTimeT: value,
        PostTime: raceInfo.PostDate + " " + value,
      });
    }

    setErrors(updatedErrors);
  };

  // PostDate handler
  const postDateChange = (datep) => {
    if (datep === null) {
      setRaceInfo({
        ...raceInfo,
        PostDate: "",
        PostTime: "",
        PostTimeT: raceInfo.PostTimeT || "00:00:00",
      });
    } else {
      let updatedPostTimeT =
        raceInfo.PostTimeT === "aN:aN:aN" ? "00:00:00" : raceInfo.PostTimeT;
      var date = new Date(datep);

      var dateString =
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + date.getDate()).slice(-2) +
        "/" +
        date.getFullYear() +
        " ";

      setRaceInfo({
        ...raceInfo,
        PostDate: dateString,
        PostTime: dateString + updatedPostTimeT,
        PostTimeT: updatedPostTimeT,
      });
    }
  };

  // This function executes the SaveRace method
  const saveRace = () => {
    var dataRace = {};
    ConfirmDialog(
      `Do you want to update <strong>${selectOption.trackCode} ${selectOption.trackName} - Race ${selectOption.raceNumber}</strong> information?`,
    ).then(async (result) => {
      if (result.isConfirmed) {
        dataRace = { ...raceInfo };

        if (dataRace.OffTime) {
          if (/aN|NaN/.test(dataRace.OffTime)) {
            dataRace.OffTime = "";
          } else {
            const raw = dataRace.OffTime.replace(/\s/g, "");
            const datePart = raw.slice(0, 10);
            const timePart = raw.slice(10);
            if (datePart.length === 10 && timePart.length === 8) {
              dataRace.OffTime = `${datePart} ${timePart}`;
            }
          }
        }

        const _errors = {};
        if (dataRace.Distance.length > 15)
          _errors.distance = "Distance 15 characters max";
        if (dataRace.Surface.length > 10)
          _errors.surface = "Surface 10 characters max";
        if (dataRace.Class.length > 100)
          _errors.class = "Class 100 characters max";
        if (("" + dataRace.Purse).length > 8)
          _errors.purse = "Purse 8 characters max";
        if (dataRace.Purse < 0) _errors.purseInv = "Purse has an invalid value";
        if (dataRace.RaceDesc.length > 255)
          _errors.raceDesc = "Race Description 255 characters max";

        if (dataRace.OffTimeT && dataRace.OffTimeT !== "aN:aN:aN") {
          const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

          if (!timeRegex.test(dataRace.OffTimeT)) {
            _errors.offTimeT = "Time must be in format hh:mm:ss";
          }
        }

        if (dataRace.OffTime === "" && dataRace.RaceStatus === "C") {
          _errors.offDate = "Date is required";
        }

        if (dataRace.PostTimeT && dataRace.PostTimeT !== "aN:aN:aN") {
          const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

          if (!timeRegex.test(dataRace.PostTimeT)) {
            _errors.postTimeT = "Time must be in format hh:mm:ss";
          }
        }

        if (
          dataRace.MTP === "" ||
          isNaN(dataRace.MTP) ||
          dataRace.RaceStatus !== "O"
        ) {
          dataRace.MTP = -128;
        }

        setErrors(_errors);
        if (Object.keys(_errors).length === 0) {
          const res = await updateRaceInfo(
            { ...dataRace },
            userInfo.LogonSessionID,
          );

          if (res?.error) {
            if (
              res.Result === ErrorCodes.InvalidSession ||
              res.Result === ErrorCodes.SessionNoLongerExists
            ) {
              setSessionNoLongerExists(true);
            }
            return;
          } else {
            successMsg("Race Saved");
            if (dataRace.MTP === -128) {
              dataRace.MTP = "";
            }
            setRaceInfo({
              ...dataRace,
              RaceStatus: dataRace.RaceStatus,
              MTP: dataRace.MTP,
            });

            racesTracks.forEach((raceI) => {
              if (raceI.RaceID === RaceID) {
                let mtp;
                if (!dataRace.MTP) {
                  mtp = -128;
                } else {
                  mtp = raceInfo.MTP;
                }
                raceI.RaceStatus = raceInfo.RaceStatus;
                raceI.MTP = mtp;
              }
            });

            setStateTracks({ ...stateTracks });
          }
        }
      }
    });
  };

  const dateInputFormat = "MM/dd/yyyy";

  const calculateMinDate = () => {
    if (raceInfo.RaceDate) {
      const tracksDatePlusOne = new Date(raceInfo.RaceDate);
      tracksDatePlusOne.setDate(tracksDatePlusOne.getDate() + 1);
      return tracksDatePlusOne;
    }
    return null;
  };

  return (
    <>
      <div className="col">
        <div className="row">
          <div className="col-sm-12" id="raceInfo">
            <WagerTypes
              raceInfo={raceInfo}
              setRaceInfo={setRaceInfo}
              lengthRaces={lengthRaces}
            />
            {/* ROW POST TIME */}
            <div className="row m-t-10 mb-2">
              <div className="col-sm-4 col-lg-2">
                <div className="form-group mb-0" key="postTimes">
                  <label htmlFor="inputCity" className="lead">
                    Post time
                  </label>
                  <DatePicker
                    ref={datePickerRef}
                    selected={Date.parse(raceInfo.PostDate)}
                    dateFormat="MM/dd/yyyy"
                    className="form-control"
                    wrapperClassName="datePicker"
                    id="postTime"
                    name="postTime"
                    autoComplete="off"
                    placeholderText="Date"
                    onChange={postDateChange}
                    onCalendarClose={handleCalendarClose}
                  />
                  <InputMask
                    className={"form-control" + classPostDateT}
                    mask="99:99:99"
                    maskChar=" "
                    id="postTimeT"
                    name="postTimeT"
                    step="1"
                    onChange={postTimeChange}
                    value={raceInfo.PostTimeT}
                  />
                </div>
                {invalidPostTime}
              </div>
              {/* ROW MTP */}
              <div className="col-sm-4 col-lg-2">
                <div className="form-group" key="mtp">
                  <label className="lead">MTP</label>
                  <div className="input-group">
                    <input
                      id="MTP"
                      type="Text"
                      onChange={onChange}
                      name="MTP"
                      className={"form-control" + classMTP}
                      value={raceInfo.MTP}
                      autoComplete="off"
                      disabled={raceInfo.RaceStatus !== "O"}
                    />
                  </div>
                  {invalidMTP}
                </div>
              </div>
              {/* ROW STATUS */}
              <div className="col-sm-4 col-lg-2">
                <div className="form-group" key="status">
                  <label htmlFor="inputState" className="lead">
                    Status
                  </label>
                  <select
                    className="form-control"
                    id="RaceStatus"
                    name="RaceStatus"
                    value={raceInfo.RaceStatus}
                    onChange={onChange}
                  >
                    <option value={"O"}>Open</option>
                    <option value={"B"}>Off</option>
                    <option value={"C"}>Completed</option>
                    <option value={"X"}>Cancelled</option>
                  </select>
                </div>
              </div>
              {/* ROW OFF TIME */}
              <div className="col-sm-4 col-lg-2">
                <div className="form-group mb-0" key="offTime">
                  <label htmlFor="inputCity" className="lead">
                    Off time
                  </label>
                  <DatePicker
                    selected={Date.parse(raceInfo.OffDate)}
                    dateFormat={dateInputFormat}
                    className={"form-control" + classOffDate}
                    wrapperClassName="datePicker"
                    id="offTime"
                    name="offTime"
                    autoComplete="off"
                    placeholderText="Date"
                    onChange={offDateChange}
                    minDate={calculateMinDate()}
                  />
                  <InputMask
                    className={"form-control" + classOffDateT}
                    mask="99:99:99"
                    maskChar=" "
                    id="offTimeT"
                    name="offTimeT"
                    step="1"
                    value={raceInfo.OffTimeT}
                    onChange={offTimeChange}
                  />
                </div>
                {invalidOffTime}
              </div>
              <div className="col-sm-4 col-lg-3">
                <div className="form-group" key="status">
                  <label htmlFor="inputState" className="lead">
                    Close Method
                  </label>
                  <select
                    className="form-control"
                    id="CloseMethod"
                    name="CloseMethod"
                    value={raceInfo.CloseMethod}
                    onChange={onChange}
                  >
                    <option value={0}>PostTime</option>
                    <option value={1}>Feed</option>
                    <option value={2}>3 MTP</option>
                    <option value={3}>2 MTP</option>
                    <option value={4}>1 MTP</option>
                    <option value={5}>0 MTP</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Steak */}
        <div className="row">
          <div className="col">{divSteak}</div>
        </div>
        <div className="" style={{ textAlign: "right" }}>
          {!isDisabled && (
            <button
              type="button"
              className="btn btn-info"
              title="Save"
              onClick={() => saveRace()}
            >
              Save
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default RaceInfo;
